import MonacoEditor from '@monaco-editor/react';
import Box from '@mui/material/Box';

const CustomJsonEditor = ({ code, height, onChange, styles = {},readOnly  }: any) => {
  const options = {
    selectOnLineNumbers: true,
    minimap: {
      enabled: false,
    },
    formatOnPaste: true,
    formatOnType: true,
    automaticLayout: true,
    readOnly
  };

  const editorDidMount = (editor: any, monaco: any) => {
    // editor.focus();
    
  };

  const onCodeChange = (newValue: any, e: any) => {
    if (!readOnly) {
      onChange(newValue);
    }
  };

  return (
    <Box sx={styles} className='monacoJsonEditor'>
      <MonacoEditor
        defaultLanguage='json'
        width='100%'
        height={height}
        theme='vs-default'
        value={code}
        options={options}
        onChange={onCodeChange}
        onMount={editorDidMount}       
      />
    </Box>
  );
};

export default CustomJsonEditor;
